import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ButtonList, PageHeader, ReportModal, Button, ArchivedReportCard, Overlay } from "../../../../Components";
import { colors, css, fonts, frames, mediaQueriesNumbers, useMediaQuery } from "../../../../Styles";

// import { TestData as ReportTemplatesData } from "../../../../Assets/TestData/reportTemplates";
import { ButtonTypes, ListStyle_Types } from "../../../../Definitions";
import { Pages } from "../../../../Navigation/Routers/root";
import { ReportTemplateData } from "../../../../Assets/TestData/reports";
import CardsView from "../../../../Assets/TestData/cardsView";
import { ReportData, ReportTemplate } from "../../../../Definitions/valueTypes";
import TemplateModal from "../../../../Components/Reports/Modals/templateModal";

export default function Reports() {
  const {t} = useTranslation()
  const [selectedTemplate, setSelectedTemplate] = useState<ReportTemplate | undefined>(undefined)
  const [reportModal, setReportModal] = useState<boolean>(false)
  const [templateModal, setTemplateModal] = useState<boolean>(false)
  const [copyTemplateMode, setCopyTemplateMode] = useState(false)

  // Mediaqueries
  const hideBtnText = useMediaQuery(`(max-width: 450px)`);
  const hideBtns = useMediaQuery(`(max-width: 600px)`);

  return (
    <frames.Page_inner>
      <frames._page_inner_header>
        <div style={{display: "flex", flexDirection: "row", alignItems: "start", justifyContent: "space-between"}}>
          <PageHeader topHeader={t(`menuHeaders.${Pages.reports}`, {defaultValue: "reports"})} subHeader={t("menuHeaders.overview", {defaultValue: "overview"})}/>
          <div style={{display: "block", zIndex: "99999"}}>
            <ButtonList 
              contents={copyTemplateMode ? [t("buttons.cancel", {defaultValue: "cancel"})] : [t("reportPages.reports.addTemplate", {defaultValue: "add template"}), t("reportPages.reports.copyTemplate", {defaultValue: "copy template"})]} 
              onClick={copyTemplateMode 
                ? (i => { 
                    if (i === 0) {setCopyTemplateMode(false)}
                  })
                : (i => { 
                  if (i === 0) {setTemplateModal(true)}
                  else if (i === 1) {setCopyTemplateMode(true)}
                })
              }
              buttonType={ButtonTypes.primaryButton}
              overrides={{
                baseButton: { ...( !hideBtns ? {...css.button_FitContent, minWidth: "none", backgroundColor: copyTemplateMode ? colors.greyPrimary : colors.greyDarkPrimary} : {backgroundColor: colors.greyDarkSecondary})},
                hoverStyles: {...(!hideBtns ? { backgroundColor: copyTemplateMode ? colors.greySecondary : colors.blackPrimary } : { backgroundColor: colors.blackPrimary })}
              }}
              listOverrides={{
                listStyle: !hideBtns ? ListStyle_Types.horizontal : ListStyle_Types.vertical,
              }}
              responsiveOverrides={{
                isResponsive: !hideBtns ? false : true,
                popoverStyle: { backgroundColor: colors.greyDarkPrimary, padding: "20px", borderRadius: "10px", boxShadow: "0px 0px 5px 2px"+colors.blackPrimary+"4d" },
                openContent: hideBtnText ? "" : t("buttons.options", {defaultValue: "options"})
              }}
            />
          </div>
        </div>
      </frames._page_inner_header>
      <frames._page_inner_content>
        <frames._page_inner_content_scroll>
          {copyTemplateMode ? <Overlay overrides={{zIndex: 9999}}/> : <></>}
          <div style={{zIndex: copyTemplateMode? "99999" : "auto", position: copyTemplateMode? "relative" : "unset"}}>
            <CardsView
              data={ReportTemplateData}
              card={(template, index) => (
                <ArchivedReportCard key={index} template={template} onCardSelect={(id) => { setSelectedTemplate(ReportTemplateData.find(template => template.templateId === id)); copyTemplateMode ? setTemplateModal(true) : setReportModal(true)}} />
              )}
              cardBtn={{
                content: t("reportPages.reports.createReport", { defaultValue: "Create Report" }),
                subContent: t("reportPages.reports.createNewReport", { defaultValue: "Start a new report from scratch" }),
                isCardBtnDisabled: copyTemplateMode,
                onCardBtnClick: () => setReportModal(true)
              }}
            />
          </div>
        </frames._page_inner_content_scroll>
      </frames._page_inner_content>

      <ReportModal 
        isModalOpen={reportModal}
        closeModal={() => { setReportModal(false); setSelectedTemplate(undefined)}}
        template={selectedTemplate}
      />
      
      <TemplateModal
        isModalOpen={templateModal}
        closeModal={() => { setTemplateModal(false); setSelectedTemplate(undefined) }}
        template={selectedTemplate}
      />

    </frames.Page_inner>
  )
}